import React from "react";
import { observer } from "mobx-react-lite";
import { Button } from "@fluentui/react-northstar";
import PropTypes from "prop-types";

const ClickableLinkBtn = observer((props) => {
  const { url, text, target, testId } = props;

  const btnClicked = () => {
    window.open(url, target);
  };

  return (
    <Button
      data-testid={testId}
      text
      content={text}
      onClick={btnClicked}
      className="non-selectable header-button"
    />
  );
});

ClickableLinkBtn.propTypes = {
  url: PropTypes.string.isRequired,
  text: PropTypes.string.isRequired,
  testId: PropTypes.string,
  target: PropTypes.string,
};

ClickableLinkBtn.defaultProps = {
  testId: "",
  target: "_blank",
};

export default ClickableLinkBtn;
